const Calendar = ({ title, events }) => {

  return {
    title,
    events
  }
}

export default Calendar